import { render, staticRenderFns } from "./TabbedView.vue?vue&type=template&id=c7a67f82&"
import script from "./TabbedView.vue?vue&type=script&lang=ts&"
export * from "./TabbedView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports